import { hbs } from 'ember-cli-htmlbars';
export default hbs("<li ...attributes>\n  <LinkTo @route={{@route}}>\n    {{yield}}\n  </LinkTo>\n</li>")